import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import type { Experimental_GeneratedImage } from "ai";
export type ImageProps = Omit<Experimental_GeneratedImage, "uint8Array"> & {
  uint8Array?: Uint8Array;
  className?: string;
  alt?: string;
};
export const Image = t0 => {
  const $ = _c(11);
  let base64;
  let mediaType;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    const {
      base64: t4,
      mediaType: t5,
      uint8Array: _uint8Array,
      ...props
    } = t0;
    base64 = t4;
    mediaType = t5;
    t1 = props;
    t2 = props.alt;
    t3 = cn("h-auto max-w-full overflow-hidden rounded-md", props.className);
    $[0] = t0;
    $[1] = base64;
    $[2] = mediaType;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    base64 = $[1];
    mediaType = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const t4 = `data:${mediaType};base64,${base64}`;
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <img {...t1} alt={t2} className={t3} src={t4} />;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};